module.exports = __webpack_public_path__ + "img/a489a32.png";